import { Box, Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  linked: boolean
  onClick: () => void
  workingConditionName?: string
}

const WorkingConditionValueTooltip = ({ linked, onClick, workingConditionName }: Props) => {
  const [open, toggle] = useToggle(false)
  const label = linked
    ? i18n.t(
        'add_employee_modal.contract_information_step.alerts.working_condition_value_tooltip.linked',
        {
          workingConditionName,
        }
      )
    : i18n.t(
        'add_employee_modal.contract_information_step.alerts.working_condition_value_tooltip.unlinked',
        {
          workingConditionName,
        }
      )
  return (
    <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={label}>
      <Box onClick={!linked ? onClick : undefined}>
        <Icon.Medium
          icon={linked ? 'link' : 'link-remove'}
          color={linked ? 'feedbackIconInfo' : 'feedbackIconWarning'}
        />
      </Box>
    </Tooltip.Alt>
  )
}

export default WorkingConditionValueTooltip
